// 动态路由生成工具

/**
 * 根据组件路径动态导入组件
 * @param {String} componentPath - 相对于 @/views 的组件路径（不含 .vue）
 * @returns {Function} - 返回动态导入函数
 */
function loadComponent(componentPath) {
  // 使用动态 import，确保生产环境也能正常工作
  return () => import(`@/views/${componentPath}.vue`)
}

/**
 * 根据菜单数据生成路由配置（扁平化，只生成叶子节点）
 * @param {Array} menus - 菜单树数据
 * @returns {Array} - 路由配置数组（扁平的）
 */
export function generateRoutes(menus) {
  if (!menus || menus.length === 0) {
    return []
  }

  const routes = []

  function flattenMenus(menuList) {
    menuList.forEach(menu => {
      // 只处理有 component 且 component 不为空的菜单（实际页面）
      if (menu.component && menu.component.trim() !== '' && menu.component !== 'Layout') {
        // 将路径转换为相对路径（作为 Layout 子路由）
        // 去掉开头的 /，例如 /products -> products, /system/roles -> system/roles
        let routePath = menu.path
        if (routePath.startsWith('/')) {
          routePath = routePath.substring(1)
        }

        const route = {
          path: routePath,
          name: menu.permissionKey,
          meta: {
            title: menu.name,
            icon: menu.icon,
            permissionKey: menu.permissionKey,
            requiresAuth: true
          }
        }

        // 解析组件 - 使用动态 import
        try {
          route.component = loadComponent(menu.component)
          console.log(`✓ 动态路由: ${routePath} → 组件: ${menu.component}`)
        } catch (error) {
          console.error(`✗ 组件加载失败: ${menu.component}`, error)
          // 失败时使用默认组件
          route.component = () => import('@/views/Dashboard.vue')
        }

        routes.push(route)
      }

      // 递归处理子菜单
      if (menu.children && menu.children.length > 0) {
        flattenMenus(menu.children)
      }
    })
  }

  flattenMenus(menus)

  // 调试输出
  console.log('==== 动态路由生成结果 ====')
  console.log('生成的路由数量:', routes.length)
  console.log('这些路由将作为 Layout 的子路由添加')
  routes.forEach(route => {
    console.log(`  路径: ${route.path} → 名称: ${route.name} → 标题: ${route.meta.title}`)
  })

  return routes
}
